import { type UseQueryResult } from '@tanstack/react-query';

import { pmsCredentials } from './endpoints.js';
import { type PmsCredentialDetail } from './schemas.js';

/**
 * Reads for the PMS credentials module.
 *
 * The list is owned by `ResourceListPage`; the detail and picker options
 * are all a credential form needs.
 */
export function usePmsCredential(id: string): UseQueryResult<PmsCredentialDetail> {
  return pmsCredentials.useItem(id);
}
